import React from 'react';
import './BlockIntegration.scss';
import './BlockIntegration-media.scss';
import CardLogo from '../CardLogo/CardLogo';
import { MediaContent } from '../../services/GlobalFunctions';
import { Props } from './interfaces';
import {content} from '../../services/content';
import {ICardLogo} from "../CardLogo/interfaces";
const blockIntegration = content.blockIntegration;

const BlockIntegration = ({ logosApi }: Props) => {
  return (
    <div className="block-integration">
      <div className="block-integration__bg"></div>
      {MediaContent(null, <div className="block-integration__bg-9"></div>)}

      <h3 className="block-integration__sub-title">{blockIntegration.textSubtitle1}</h3>
      <div className="block-integration__logos">
        {logosApi.map((item, i) => (
          <CardLogo card={item} key={i} />
        ))}
      </div>

      <h3 className="block-integration__sub-title">{blockIntegration.textSubtitle2}</h3>
      <div className="block-integration__logos">
        {blockIntegration.logos.apiPartners.map((item: ICardLogo, i: number) => (
          <CardLogo card={item} key={i} />
        ))}
      </div>
    </div>
  );
};

export default BlockIntegration;
